module.exports = __webpack_public_path__ + "static/8m-9ae17409347538180939729e770160b2.jpg";